module.exports = __webpack_public_path__ + "static/hx-9844e5c4fdd2ddc187ca0f8520f9abdb.png";